import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBronzeMedal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={28}
    height={28}
    fill='none'
    {...props}
  >
    <path
      fill='#C27B38'
      d='M21.276 22.491a1 1 0 0 1-1.44.831l-6.495-3.197a1 1 0 0 1-.058-1.763l6.974-4.026a1 1 0 0 1 1.498.932z'
    />
    <path
      fill='#C27B38'
      d='M5.8 22.491a1 1 0 0 0 1.44.831l6.495-3.197a1 1 0 0 0 .058-1.763L6.82 14.336a1 1 0 0 0-1.498.932z'
    />
    <rect width={18} height={18} x={4.978} y={1} fill='#E39E5C' rx={9} />
    <rect
      width={18}
      height={18}
      x={4.978}
      y={1}
      stroke='#C27B38'
      strokeWidth={2}
      rx={9}
    />
    <path
      fill='#92602E'
      d='M14.001 14.17q-.925 0-1.623-.31a2.7 2.7 0 0 1-1.096-.862 2.5 2.5 0 0 1-.457-1.283l-.006-.07h1.442l.006.064q.04.357.263.639a1.5 1.5 0 0 0 .598.433q.374.153.873.153.486 0 .85-.17.369-.17.574-.47.204-.298.205-.69v-.012q0-.668-.463-1.026-.463-.357-1.277-.357h-1.002V9.084h.972q.463 0 .815-.164a1.3 1.3 0 0 0 .545-.445q.193-.287.193-.657v-.011q0-.393-.17-.668a1.06 1.06 0 0 0-.486-.422 1.8 1.8 0 0 0-.768-.147q-.445 0-.79.153a1.305 1.305 0 0 0-.791 1.084l-.007.058h-1.4l.006-.07q.064-.732.445-1.272a2.55 2.55 0 0 1 1.031-.843q.651-.305 1.506-.305.873 0 1.518.287.645.281.996.78.357.497.357 1.165v.012q0 .522-.234.926a1.9 1.9 0 0 1-.633.662 2.6 2.6 0 0 1-.908.37v.028q.938.089 1.506.622.568.527.568 1.406v.012q0 .739-.398 1.312-.399.569-1.113.89-.71.324-1.647.323'
    />
    <path
      fill='#ECBA8A'
      d='m17.618 3.632-.865-.384-1.15-.357-.337.269-.036.383.212.406.275.232.716.297.636.343.549.358.494.382.557.501.461.676.29.39.423.12.275-.168v-.698l-.275-.487-.423-.75-.29-.324-.526-.57-.582-.409z'
    />
  </svg>
);
export default SvgBronzeMedal;
